import React, { useState, useEffect, useContext } from "react"
import Page from "../pages/page"
import {PageProvider} from "../context/pageContext"
import {SectionProvider} from "../context/sectionContext"
import {JourneyProvider} from "../context/journeyContext"
import {ConditionProvider} from "../context/conditionContext"
import {ErrorProvider} from "../context/errorContext"
import {RepeatableProvider} from "../context/repeatableContext"
import { JourneyContext } from "../context/journeyContext"
import { fetchDomain, getConfigurationsByType, getIpAddress,getJWTTokenForIp } from "../../services/apiservice"
import * as lookup from "../../../static/lookup.json"
import { refreshToken  } from "../../interceptors/jwt-interceptor"
import { navigate } from "gatsby"
import TpaContextProvider from "../context/tpaContext"
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
import { saveAgentDetails } from "../../services/apiservice"

const JourneyOne = (props) => {
  const [journeyState,setJourneyState] = useContext(JourneyContext)
  const pages = journeyState.journeySteps.pages
  const [currentPageIndex, setCurrentPageIndex] = useState(0)
  const [showFirstSectionFields, setShowFirstSectionFields] = useState(false)
  useEffect(() => {
    if(props.channel){
      setJourneyState(prev => {
        return({
          ...prev,
          // channel: lookup["reverseChannelType"]?.[0]?.[props.channel.toUpperCase()] || "D"
          channel: lookup["reverseChannelType"]?.[0]?.[props.channel.toUpperCase()] || props.channel
        })
      })

    }
  }, [props.channel])

  // Common function to fetch and process domains and emails
  const fetchDomainsAndEmails = async () => {
    try {
      const payloadToFetchDomains = {
        channel: lookup["reverseChannelType"]?.[0]?.[props.channel.toUpperCase()] || props.channel
      }
      const payloadToFetchConfigurations = {
        type: "email-whitelist-config",
        product: journeyState.journeyIdFromStrapi,
        channel: lookup["reverseChannelType"]?.[0]?.[props.channel.toUpperCase()] || props.channel
      }
      
      // Make parallel API calls
      const [domains, configurations] = await Promise.all([
        fetchDomain(payloadToFetchDomains),
        getConfigurationsByType(payloadToFetchConfigurations)
      ])
      
      const separatedDomains = domains?.domain || []
      const separatedEmails = configurations?.data || []
      
      if(separatedDomains.length === 0 && separatedEmails.length === 0){
        navigate("/invalidChannel")
        return
      }
      
      setJourneyState(prev => ({
        ...prev,
        corpDiscDomains: separatedDomains,
        corpDiscEmails: separatedEmails
      }))
    } catch (error) {
      console.error("Error fetching domains and configurations:", error)
      navigate("/invalidChannel")
    }
  }

  useEffect(() => {
     if (props.channel && journeyState.corpDiscOpt === "Y") {
      getIpAddress()
        .then(async res => {
          const payload = {
            ip: res.IPv4
          }
          
          if (refreshToken) {
            await fetchDomainsAndEmails()
          } else {
            getJWTTokenForIp(payload)
              .then(async res => {
                await fetchDomainsAndEmails()
              })
          }
        })
    }
  }, [props.channel, journeyState.corpDiscOpt])

  let temp = journeyState.journeySteps
  const changeJourneySteps = (pageId, sectionId, componentGroup, componentFormControlKey, key , value) => {
    try{
      let tempPageIndexToChange = temp.pages.findIndex(element => element.pageId === pageId)
      let tempSectionIndexToChange = temp.pages[tempPageIndexToChange].sections.findIndex(element => element.sectionId === sectionId)
      let tempComponentGroupIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups.findIndex(element => element.componentId === componentGroup)
      let tempComponentIndexToChange = temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey === componentFormControlKey)
      console.log(tempPageIndexToChange, tempSectionIndexToChange, tempComponentGroupIndexToChange, tempComponentIndexToChange, "======>ImpTemp0")
      temp.pages[tempPageIndexToChange].sections[tempSectionIndexToChange].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndexToChange][key] = value
    }catch(err){
      console.log(err, "=====>ErrorInPage.js===Line-152")
    } 
  }

  useEffect(() => {
    if(props.rmData || props.hsbcBankData){
      let fillProposalPageId
      let firstPageId
      let firstSection
      let secondSectionId = "iSelect360CPResidentAndOccupationDetailSection"
      if(journeyState.journeyIdFromStrapi === "iSelectJourney"){
          fillProposalPageId = "fillProposalForm"
          firstPageId = "calculatePremiumPage"
          changeJourneySteps(firstPageId, "CPResidentAndOccupationDetailSection", "CPResidentAndOccupationDetail", "country", "disabled", true)
      changeJourneySteps(firstPageId, "CPResidentAndOccupationDetailSection", "CPResidentAndOccupationDetail", "state", "lookupKey", "state_RM")
      }else if(journeyState.journeyIdFromStrapi === "ISelect360Journey"){
          fillProposalPageId = "pageISelect360FillProposalForm"
          firstPageId = "PageISelect360CalculatePremium"
          changeJourneySteps(firstPageId, "iSelect360CPResidentAndOccupationDetailSection", "iSelect360CPResidentAndOccupationDetail", "country", "disabled", true)
          changeJourneySteps(firstPageId, "iSelect360CPResidentAndOccupationDetailSection", "iSelect360CPResidentAndOccupationDetail", "state", "lookupKey", "state_RM")
          changeJourneySteps(firstPageId, "iSelect360CPResidentAndOccupationDetailSection", "iSelect360CPResidentAndOccupationDetail", "residentStatus", "disabled", false)
          //for Spouse Lookup change
          changeJourneySteps(firstPageId, "iSelect360CPSpouseCoverDetails", "iSelect360CPSpouseCoverDetail2AI", "residentStatus", "lookupKey", "residentstatus_spouse_RM")
           // For Spouse
           changeJourneySteps(fillProposalPageId, "spouseQuestionnaire", "spouseMobile-No-order-5", "countryCode", "disabled", true)
           changeJourneySteps(fillProposalPageId, "spouseQuestionnaire", "residenceCountry-order-17", "reisdentialCountry", "disabled", true)
           changeJourneySteps(fillProposalPageId, "spouseQuestionnaire", "residentStatus-order-18", "residentStatus", "disabled", true)
           changeJourneySteps(fillProposalPageId, "spouseQuestionnaire", "nationality-order-19", "residentialNationality", "disabled", true)
           changeJourneySteps(fillProposalPageId, "spouseQuestionnaire", "countryOfBirth-order-20", "residentialCountryOfBirth", "disabled", true)
      }else if(journeyState.journeyIdFromStrapi ===  "youngTermPlanJourney"){
        fillProposalPageId = "pageISelect360FillProposalForm"
        firstPageId = "PageP2PCalculatePremium"
        firstSection = "sectionP2PPersonalDetailsSection"
        // changeJourneySteps(firstPageId, "P2PCPResidentAndOccupationDetailSection", "P2PPlanCPResidentAndOccupationDetail", "country", "disabled", true)   //enables country code in residenceDetailsSection for hsbc 
        changeJourneySteps(firstPageId, "P2PCPResidentAndOccupationDetailSection", "P2PPlanCPResidentAndOccupationDetail", "state", "lookupKey", "state_RM")
        // changeJourneySteps(firstPageId, "P2PCPResidentAndOccupationDetailSection", "P2PPlanCPResidentAndOccupationDetail", "residentStatus", "disabled", true)  //enables resident status in residenceDetailsSection for hsbc
        //for Spouse Lookup change
        changeJourneySteps(firstPageId, "P2PCPSpouseCoverDetails", "iSelect360CPSpouseCoverDetail2AI", "residentStatus", "lookupKey", "residentstatus_spouse_RM")
         // For Spouse
         changeJourneySteps(fillProposalPageId, "spouseQuestionnaire", "spouseMobile-No-order-5", "countryCode", "disabled", true)
         changeJourneySteps(fillProposalPageId, "spouseQuestionnaire", "residenceCountry-order-17", "reisdentialCountry", "disabled", true)
         changeJourneySteps(fillProposalPageId, "spouseQuestionnaire", "residentStatus-order-18", "residentStatus", "disabled", true)
         changeJourneySteps(fillProposalPageId, "spouseQuestionnaire", "nationality-order-19", "residentialNationality", "disabled", true)
         changeJourneySteps(fillProposalPageId, "spouseQuestionnaire", "countryOfBirth-order-20", "residentialCountryOfBirth", "disabled", true)
    } else if(journeyState.journeyIdFromStrapi === "Promise2ProtectJourney"){
        fillProposalPageId = "pageISelect360FillProposalForm"
        firstPageId = "PageP2PCalculatePremium"
        firstSection = "sectionP2PPersonalDetailsSection"
        secondSectionId = "SectionCommonResidenceAndOccupation"
        // changeJourneySteps(firstPageId, "P2PCPResidentAndOccupationDetailSection", "P2PPlanCPResidentAndOccupationDetail", "country", "disabled", true)   //enables country code in residenceDetailsSection for hsbc 
        changeJourneySteps(firstPageId, "P2PCPResidentAndOccupationDetailSection", "P2PPlanCPResidentAndOccupationDetail", "state", "lookupKey", "state_RM")
        // changeJourneySteps(firstPageId, "P2PCPResidentAndOccupationDetailSection", "P2PPlanCPResidentAndOccupationDetail", "residentStatus", "disabled", true)  //enables resident status in residenceDetailsSection for hsbc
        //for Spouse Lookup change
        changeJourneySteps(firstPageId, "P2PCPSpouseCoverDetails", "iSelect360CPSpouseCoverDetail2AI", "residentStatus", "lookupKey", "residentstatus_spouse_RM")
         // For Spouse
         changeJourneySteps(fillProposalPageId, "spouseQuestionnaire", "spouseMobile-No-order-5", "countryCode", "disabled", true)
         changeJourneySteps(fillProposalPageId, "spouseQuestionnaire", "residenceCountry-order-17", "reisdentialCountry", "disabled", true)
         changeJourneySteps(fillProposalPageId, "spouseQuestionnaire", "residentStatus-order-18", "residentStatus", "disabled", true)
         changeJourneySteps(fillProposalPageId, "spouseQuestionnaire", "nationality-order-19", "residentialNationality", "disabled", true)
         changeJourneySteps(fillProposalPageId, "spouseQuestionnaire", "countryOfBirth-order-20", "residentialCountryOfBirth", "disabled", true)
    } else {
        return
      }
      // changeJourneySteps(firstPageId, "CPPersonalDetailsSection", "contactNo", "contactCountryCode", "disabled", true)
      if(props?.hsbcBankData?.editable && firstPageId && firstSection){
        const editable = props.hsbcBankData.editable;
        const editableName = editable?.firstName || editable?.middleName || editable?.lastName;
        changeJourneySteps(firstPageId, firstSection, "CPPersonalDetailName", "CPPersonalDetailName", "disabled", !editableName)        
        const phoneNumberEditable = editable?.phone;
        changeJourneySteps(firstPageId, firstSection, "contactNo", "contactNumber", "disabled", !phoneNumberEditable)
        const phoneCountryCodeEditable = editable?.phoneCountryCode;
        changeJourneySteps(firstPageId, firstSection, "contactNo", "contactCountryCode", "disabled", !phoneCountryCodeEditable)
        const emailEditable = editable?.email;
        changeJourneySteps(firstPageId, firstSection, "email", "email", "disabled", !emailEditable)
        const titleEditable = editable?.title;
        changeJourneySteps(firstPageId, firstSection, "CPPersonalDetailName", "laTitle", "disabled", !titleEditable)
        changeJourneySteps(firstPageId, firstSection, "CPPersonalDetailName", "CPPersonalDetailName", "class", 'col-lg-4 col-md-12 col-12')


      }

      if (props?.hsbcBankData?.currentCountry && !props?.hsbcBankData?.editable?.country){
        changeJourneySteps(firstPageId, secondSectionId , "country", "country", "disabled", !props?.hsbcBankData?.editable?.country)
        
        // pincode can only be frozen in country exists and is valid
        // alternatecase: pincode fields if freezed but since country is not valid, pincode will be undetiable in india's case
        if (props?.hsbcBankData?.pincode && !props?.hsbcBankData?.editable?.pincode){
          changeJourneySteps(firstPageId, secondSectionId , "pincode", "pincode", "disabled", !props?.hsbcBankData?.editable?.pincode)
        }
      }

      changeJourneySteps(fillProposalPageId, "personalDetailsSection", "alternateMobileNo", "AlternateMobCountryCode", "disabled", false)

      changeJourneySteps(fillProposalPageId, "residenceDetailsSection", "residentialCountry", "residentStatus", "disabled", true)
      changeJourneySteps(fillProposalPageId, "residenceDetailsSection", "residentialCountry", "residentialCountryOfBirth", "disabled", true)
      changeJourneySteps(fillProposalPageId, "residenceDetailsSection", "residentialCountry", "residentialCitizenship", "disabled", true)
      changeJourneySteps(fillProposalPageId, "residenceDetailsSection", "residentialCountry", "residentialNationality", "disabled", true)
      changeJourneySteps(fillProposalPageId, "residenceDetailsSection", "residentialCountry", "residentialTaxResidentialCountry", "disabled", true)

      changeJourneySteps(fillProposalPageId, "residenceDetailsSection", "permanentResidentialDetails", "PRCountry", "disabled", true)
      changeJourneySteps(fillProposalPageId, "residenceDetailsSection", "permanentResidentialDetails", "PRState", "lookupKey", "state_RM")

      console.log(temp, "======>ImpTemp")
      if(props.rmData){
        setJourneyState(prev => {
          return({
            ...prev,
            channel: "A",
            rmLedJourney: "Y",
            agentDetails: {
              "rmLedJourneyInd" : "01",
              "rmLedFNAInd": "N",
              "hsbcRMName": props.rmData?.LEVEL1_NAME,
              "hsbcRMMobileNo": props.rmData?.JV_RM_PHONE_NO,
              "rmLedAgentId": props.rmData?.LEVEL1_ID_SP,
              "hsbcRMEmailId": props.rmData?.MAIL_ID,
              "rmName" : props.rmData?.LEVEL1_NAME,
              "rmContactNo" : props.rmData?.JV_RM_PHONE_NO,
              "rmLedAgentBRCode": props.rmData?.BRANCHID,
              "rmLedAgentBRName": props.rmData?.BRANCH_LOCATION
            },
            journeySteps: temp
          })
        })
      }
    }
  }, [props.rmData, props.hsbcBankData])

  useEffect(()=>{
    if (props?.BQPData){
      setJourneyState(prev => {
        return ({
          ...prev,
          channel: lookup.reverseChannelType[0][props.BQPData?.channelName?.toUpperCase()] || props.BQPData?.channelName,
          rmLedJourney: "Y",
          journeyType : "Broker",
          agentDetails: {
            "rmLedJourneyInd": "02",
            "rmLedFNAInd": "N",
            "rmLedAgentId":props.BQPData?.BQPName,
            "rmLedAgentBRCode": props.BQPData?.BQPName
          }
        })
      })
      // save agent details api
      if (props.BQPData?.shouldSaveAgentDetails){
        const payload = {
          journeyId : props?.BQPData?.resumeJourneyData?.journeyData._id,
          channel : lookup.reverseChannelType[0][props.BQPData?.channelName?.toUpperCase()] || props.BQPData?.channelName,
          agentDetails : {
            "rmLedJourneyInd": "02",
            "rmLedFNAInd": "N",
            "rmLedAgentId":props.BQPData?.BQPName,
            "rmLedAgentBRCode": props.BQPData?.BQPName
          }
        }
        saveAgentDetails(payload)
        .then(() => {})
        .catch((err) => {})
      }
    }
  },[props.BQPData])

  return (
    <>
      <GoogleReCaptchaProvider reCaptchaKey={process.env.RECAPTCHA_SITE_KEY}>
        <PageProvider>
          <SectionProvider>
            <ConditionProvider>
              <ErrorProvider>
                <RepeatableProvider>
                  <TpaContextProvider>
                  <style>
                    {`
                      .input-group.date .input-group-addon{
                        background:none;
                      }
                
                      @media (max-width: 767px){

                        .form-group {
                          margin-bottom: 34px;
                        }
                        
                      }
                      .threetabs ul li:nth-child(2).active, .threetabs ul li:nth-child(3).active, .threetabs ul li:nth-child(4).active{
                        margin-left:-2px;
                      }
                      
                    .threetabs ul li:nth-child(2).active, .threetabs ul li:nth-child(3).active, .threetabs ul li:nth-child(4).active{
                      margin-left:-2px;
                    }
                    ::-ms-clear {
                      display: none;
                    }    
                    .d-none{
                      display: none;
                    }   
                    .br-0{
                      border-radius: 0px !important;
                    }
                  `}
                </style>

                {/* <!--Step design Start--> */}
                <div className="container">
                  <div className={`${props.channel} threetabs left-tab-listing-design`}>
                    {/* className="tabsthree active" */}
                    <ul>
                      {pages?.map((page, index, arr) => {
                        return (
                          <li
                            className={
                              index === 0
                                ? `${index <= currentPageIndex ? "tabsone active" : ""} ${index < currentPageIndex ? "br-0" : ""}`
                                : index === pages.length - 1
                                ? `${index <= currentPageIndex ? "tabsthree active" : ""} ${index < currentPageIndex ? "br-0" : ""}`
                                : `${index <= currentPageIndex ? "tabstwo active" : ""} ${index < currentPageIndex ? "br-0" : ""}`
                            }
                            key={page?.pageId}
                          >
                            <a>{page?.name}</a>
                            <span className={`${index < arr.length-1 ? "fa fa-angle-right" : "d-none"}`}></span>
                          </li>
                        )
                      })}
                    </ul>
                  </div>
                </div>
                  {/* <!--mobile-progress--> */}
                  <div className="progress-mobile-bg-structure">
                    <div className="mobile-progressbar-design-new mobile-progress-structure-design">
                      <ul className="nav nav-tabs mobile-progressbar-design-new-nav">
                        {pages?.map((page,index) => {
                          return(
                            <li className={`${index <= currentPageIndex ? "active" : ""}`} key={page?.pageId}>
                              {" "}
                              <a>
                                <span className="fa fa-angle-right"></span>
                              </a>
                              <div className={`${index < pages.length-1 ? "liner" : ""} ${index <= currentPageIndex ? "active" : ""}`}></div>
                            </li>
                          )
                        })}
                      </ul>
                    </div>
                    <div className="mobile-resume-structure">
                      <div className="app-quatation mt">
                        <div className="application-design-number">
                          Application Number: {journeyState.applicationNo}
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* <!--mobile-progress-->  */}
                  {/* <!--Step design End-->  */}

                  <Page sections={pages?.[currentPageIndex]?.sections} pageId={pages?.[currentPageIndex]?.pageId} currentPageIndex={currentPageIndex} setCurrentPageIndex={setCurrentPageIndex} pages={pages}  resumeJourneyData={props.resumeJourneyData || props?.BQPData?.resumeJourneyData} decryptData={props.decryptData} digilockerdata={props.digilockerdata} journeyId={props.journeyId} paymentData={props.paymentData} enachData={props.enachData} showFirstSectionFields={showFirstSectionFields} setShowFirstSectionFields={setShowFirstSectionFields} canaraPosData={props.canaraPosData} hsbcBankData={props.hsbcBankData} lienData={props.lienData} />
                </TpaContextProvider>
                </RepeatableProvider>
              </ErrorProvider>
            </ConditionProvider>
          </SectionProvider>
        </PageProvider>
      </GoogleReCaptchaProvider>
    </>
  )
}

export default JourneyOne
